{
  "white": "#fff",
  "charcoal": "#1E2021",
  "border": "#EDEEF4",
  "lighter-grey": "#F6F7FB",
  "light-grey": "#EDEEF4",
  "grey": "#D5D8E1",
  "dark-grey": "#979FB5",
  "green": "#34B27D",
  "blue": "#0365D6",
  "purple": "#8B572A",
  "bug": "#ea4444",
  "issue": "#E09952",
  "light-blue": "#68D6F7",
  "light-pink": "#FEF2F8",
  "pink": "#FD8BC1",
  "red": "#EA4444"
}
